<template>
  <div class="OnlineReading" @click="toBuy">
    <img src="@/assets/img/qietu/buy.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "BuyButton",
  inject: ["payUrl"],
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type,
    };
  },
  methods: {
    // 去购买
    toBuy() {
      if (this.$route.query.out && !this.$global.isAndroid_ios()) {
        window.webkit.messageHandlers.courseEnroll.postMessage(this.payUrl());
      } else {
        window.location.href = this.payUrl();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.OnlineReading {
  width: 45px;
  height: 45px;
  background: rgb(255, 255, 255);
  color: #fff;
  margin-bottom: 10px;
  text-align: center;
  line-height: 54px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
